// extracted by mini-css-extract-plugin
module.exports = {"deleteIcon":"DeleteAppConfigButton_deleteIcon__x14-r"};